export default "__VITE_ASSET__DfrGHNGt__"